import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Page, Card, Typography } from 'seagull';
import { CopyToClipboard } from '~/components/CopyToClipboard/CopyToClipboard';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useEventReporter } from '~/event-reporter';
import { useSetDocumentTitle } from '~/hooks/useSetDocumentTitle';
import { useLocaleKeys } from '~/i18n';
import { sendErrReport } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
import { helpArticles } from '~/utils/helpArticles';
import styles from './ReferralDashboardOld.module.scss';
export function ReferralDashboardOld() {
    const { t: texts } = useLocaleKeys('pages.referralDashboard');
    const { api, logBI } = useStoreActions();
    const { sendEventToGtm } = useEventReporter();
    const [referral, setReferral] = useState();
    const [loading, setLoading] = useState(true);
    useSetDocumentTitle('Referrals');
    useEffect(()=>{
        api.user.referral().then((referralData)=>{
            setReferral(referralData);
            setLoading(false);
        });
    }, []);
    return /*#__PURE__*/ _jsx(Page, {
        header: texts.header(),
        subheader: texts.subheader(),
        skin: "secondary",
        testId: "referral-dashboard",
        loading: loading,
        children: /*#__PURE__*/ _jsxs(Card, {
            bi: {
                name: 'referral_dashboard_old_card'
            },
            title: texts.cardTitle(),
            autoHeight: true,
            padding: "m",
            className: styles.card,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsxs(Typography, {
                        children: [
                            texts.shareDescription(),
                            ' ',
                            /*#__PURE__*/ _jsx(ExternalLinkButton, {
                                openInNewTab: true,
                                href: helpArticles.referralProgram(),
                                bi: {
                                    name: 'referral_program_read_more'
                                },
                                children: texts.readMore()
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.innerCard,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph1",
                            weight: "bold",
                            children: texts.shareReferralLink()
                        }),
                        /*#__PURE__*/ _jsx(CopyToClipboard, {
                            value: referral === null || referral === void 0 ? void 0 : referral.referralLink(),
                            testId: "referral-link",
                            onError: ()=>sendErrReport('Failed to copy referral link'),
                            onCopy: ()=>{
                                logBI(18150);
                                sendEventToGtm('refer_a_friend_copy_link', {});
                            },
                            disabled: loading
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            testId: "credits-earned",
                            children: texts.creditsEarned({
                                amount: referral ? referral.creditsEarnedFormatted() : '$0'
                            })
                        })
                    ]
                })
            ]
        })
    });
}
